export default "__VITE_ASSET__BEp$b1hz__"